import React, {useState, useContext} from "react";
import { FiChevronLeft } from "react-icons/fi";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import TradeView from "./trade-view-body-container/trade-view";
import TradeViewButtonContainer from "./trade-view-button-container/trade-view-button-container";
import TradeViewIntegrationContainer from './trade-view-body-container/TradeViewIntegrationContainer';
import TradeViewManualContainer from "./trade-view-body-container/TradeViewManualContainer";
import ServerTimeout from "./trade-view-body-container/server-timeout/server-timeout";
import "./trade-view-container.css";
import ClientInfoBody from "./trade-view-body-container/client-info-body/client-info-body";
import ClientInfoHeader from "./trade-view-body-container/client-info-header/client-info-header";
import IncompleteClient from "./trade-view-body-container/incomplete-client/incomplete-client";
import ServerUnavailable from "./trade-view-body-container/server-unavailable/server-unavailable";
import { Button } from "react-bootstrap";
import AuthContext from "../../../../auth/auth-context";
import TradeContext from "../../../../store/tradeState/tradeContext";
import axios from "axios";

const errorGroup = [16, 17, 18, 19];

function TradeViewContainer(props) {
  const [tradeScreen, setTradeScreen] = useState('summary'); // summary, manual_booking, integration
  const [loading, setLoading] = useState(false);
  const authCtx = useContext(AuthContext);
  const tradeCtx = useContext(TradeContext);

  const [error, setError] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const headers = {
    "Acting-as": "dealer",
    Authorization: `JWT ${authCtx?.token}`,
  };

  const completeTrade = async () => {
try {
  setLoading(true);
  const tradeId = props.inTrade.id;
  const compelteTradeRes = await axios.post(`${process.env.REACT_APP_SERVER_URL}/trades/${tradeId}/set_completed/`, {}, { headers: headers })
      if(compelteTradeRes.status === 200) {
        setLoading(false);
        tradeCtx.getTrades();
        tradeCtx.updateTrade(tradeId, { status: "COMPLETED" });
        tradeCtx.setTrade({ ...props.inTrade, status: "COMPLETED" });
        props.close();
      }
} catch(error){
  console.error('Error completing trade:', error);
  setLoading(false);
  setError(true);
  setErrorMessage(error.response?.data?.message || "An error occurred while completing the trade.");
}
  }

  return (
    <>
      <Modal
        animation={false}
        show={props.isShown}
        onHide={() => {
          props.close();
        }}
        size="lg"
        container={document.body}
        enforceFocus={false}
      >
        <Modal.Header>
          {errorGroup.find((e) => e === props.inTrade.status.code) ? (
            <span>Trade Fail Management</span>
          ) : (
            <div className="row fw">
              <div className="col-10 ">
                <span className="reduced-header">
                  {props.inTrade.customer.name}
                </span>
              </div>
            </div>
          )}
          {/* {props.inTrade.status === 'BOOKED' && (
            <Button disabled={loading} variant="success" onClick={completeTrade} style={{ whiteSpace: 'nowrap' }}>
                        {loading ? 'Loading...' : 'Complete Trade'}
                      </Button>
          )} */}
        </Modal.Header>
        <Modal.Body>
          <div className="trade-btn-header-container">
            {tradeScreen !== 'summary' && (
            <button
              type="button"
              className="tv-back"
              onClick={() => setTradeScreen('summary')}
              aria-label="Back to summary"
            >
              <FiChevronLeft className="tv-back__icon" aria-hidden />
              <span className="tv-back__label">Back</span>
            </button>
          )}
          </div>

          {tradeScreen === 'summary' && (<><TradeView inTrade={props.inTrade} setTradeScreen={setTradeScreen} close={props.close} /></>)}
          {tradeScreen === 'manual_booking' && <TradeViewManualContainer close={props.close}
            tryLater={props.close}
            mailSupport={props.close}
            clientView={props.close}
            cancelTrade={props.close}
            retryDeal={props.callbackRetry}
            code={props.inTrade.status.code}
            tradeId={props.inTrade.id}
            status={props.inTrade.trade_status}
            trade={props.inTrade} />}
          {tradeScreen === 'integration' && <TradeViewIntegrationContainer inTrade={props.inTrade} setTradeScreen={setTradeScreen} />}

          
        </Modal.Body>
        
        
        
      </Modal>
    </>
  );
}

TradeViewContainer.propTypes = {
  inTrade: PropTypes.object,
  isShown: PropTypes.bool,
  close: PropTypes.func,
  callbackCancel: PropTypes.func,
  callbackRetry: PropTypes.func,
  callbackConfirm: PropTypes.func,
  config: PropTypes.bool,
};

export default TradeViewContainer;
